import useSWR from 'swr'
import { defaultState } from '../fetchWebcastCommunities'
import convertMinutesToMilliseconds from '../convertMinutesToMilliseconds'
import useGigIDs from '../useGigIDs'

/** Will pass the initial state from the PageContent object, then revalidate. Subsequent calls won't need to pass initial state as it will be cached */
const useWebcastCommunities = (initialData = defaultState, hostUrl) => {

  const { channelId, webcastId } = useGigIDs()

  return useSWR(channelId && webcastId ? [ 'webcastCommunities', hostUrl, '', channelId, webcastId ] : null, {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {

      if (error.status === 404) return

      // Retry every minute on failure
      setTimeout(() => revalidate({ retryCount: retryCount + 1 }), convertMinutesToMilliseconds(2))

    },
    initialData,
    revalidateOnMount: true,
    revalidateOnFocus: false
  })

}

export default useWebcastCommunities
